import type { TrackableProduct } from 'types/TrackableProduct';

import {
  type ContractStockStatus,
  type StockStatus,
  toContractStockStatus
} from '~/domain/stockStatus';

import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type RetailerOption = {
  available_sizes: string[];
  position: number;
  price_currency: string;
  price_regular: number;
  price_sale?: number;
  retailer_id?: string;
  stock_status?: StockStatus;
};

type WireRetailerOption = Omit<RetailerOption, 'stock_status'> & {
  stock_status?: ContractStockStatus;
};

export type RetailerTargetProperties = {
  product_id?: string;
  retailer_id?: string;
  retailers: WireRetailerOption[];
  selected_size?: string;
};

type EventData = {
  gesture?: string;
  isBot: boolean;
  product: TrackableProduct;
  retailerId?: string;
  retailers: RetailerOption[];
  selectedSize?: string;
};

class RetailerInteractionEvent extends InteractionEvent<
  EventData,
  RetailerTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'retailer';
  }

  protected getTargetProperties(): RetailerTargetProperties {
    return {
      product_id: this.data.product.product_id?.toString(),
      retailer_id: this.data.retailerId,
      retailers: this.data.retailers.map(({ stock_status, ...option }) => ({
        ...option,
        stock_status: stock_status
          ? toContractStockStatus(stock_status)
          : undefined
      })),
      selected_size: this.data.selectedSize
    };
  }
}

export default RetailerInteractionEvent;
